import React, { Component, useState } from "react";
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import ChatSupportBtn from "./ChatSupportBtn";
import {
  logout,
  chkapiinput,
  checkTime,
  checkBanner,
  bannertimer,
  generateId,
} from "./Utility";
import moment from "moment";
import Modal from "antd/lib/modal/Modal";
import Calender from "../assets/images/Calender.svg";
import UPI from "../assets/images/upi.svg";
import Clock from "../assets/images/Clock.svg";
import Cash from "../assets/images/cash.JPG";
import Nach from "../assets/images/nach.png";
import customFetch from "./apicall/api";
import { ThemeContext } from "../context/IsLoader";
import { List, Pagination } from "antd";
// import $ from "jquery";

const generate_Id1 = generateId(10);
class Other_collection extends Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.sortModal = React.createRef();
    this.state = {
      items: [],
      cnames: [],
      og_data: [],
      branch_list: [],
      sort_header: "",
      sort_htl: "",
      sort_data: [],
      search_text: "",
      uniqueNames: [],
      uniqueLocation: [],
      temp_array: [
        "dFilter1",
        "dFilter2",
        "dFilter3",
        "dFilter4",
        "dFilter5",
        "bFilter1",
        "bFilter2",
        "bFilter3",
        "bFilter4",
        "bFilter5",
        "cFilter1",
        "cFilter2",
        "cFilter3",
        "cFilter4",
        "cFilter5",
      ],
      counter: 1,
      searchModal: false,
      isShowName: true,
      isShowLoc: false,
      isShowDem: false,
      isShowBal: false,
      isShowCol: false,
      isLoaded: false,
      isErrOpen: false,
      isHHReg: false,
      api_error_message: "",
      MenuName: "",
      notCalledCount: 0,
      a0: 0,
      a1: 0,
      a2: 1,
      a3: 1,
      a4: 1,
      a5: 1,
      a6: 1,
      b0: 0,
      b1: 0,
      b2: 1,
      b3: 1,
      b4: 1,
      b5: 1,
      b6: 1,
      c0: 0,
      c1: 0,
      c2: 1,
      c3: 1,
      c4: 1,
      c5: 1,
      c6: 1,
      callsort: 0,
      household_id: "",
      issendQR: false,
      isSmssent: false,
      smsSentmsg: "",
      isSpin: false,
      smsmobile: "",
      smsmobileErr: "",
      issmsmobile: false,
      issmsamount: false,
      hhnumber: "",
      isLogout: false,
      time_flag: 0,
      isModalOpen: false,
      isOpenCollect: false,
      historyState: {},
      previous_transactions: [],
      D_count: 0,
      C_count: 0,
      B_count: 0,
      Full_pay: 0,
      Part_pay: 0,
      No_pay: 0,
      data_filter: "month",
      isDay: false,
      isDate: false,
      isMonth: true,
      collectionmode: [],
      errorMsg: [],
      isOpen: false,
      fliped: false,
      chequeOCRdata: [],
      isReload: false,
      isDisablecollection: false,
      currentPage: 1,
      pageSize: 20,
    };

    this.handlesort = this.handlesort.bind(this);
    this.handlesorthtl = this.handlesorthtl.bind(this);
    this.handleSearchText = this.handleSearchText.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.filter = this.filter.bind(this);
    this.handleFilterMenu = this.handleFilterMenu.bind(this);
    this.addName = this.addName.bind(this);
    this.handlesortdbc = this.handlesortdbc.bind(this);
    this.handleCallSort = this.handleCallSort.bind(this);
    this.getData = this.getData.bind(this);
    this.checkDates = this.checkDates.bind(this);
  }
  // handleOkModal = () => {
  //   this.setState({ isModalOpen: false });
  //   this.props.history.push({
  //     pathname: "/CollectionReceipt",
  //     state: {
  //       ...this.state.historyState,
  //     },
  //   });
  // };
  // handleChange = (e) => {
  //   if (e.target.name == "cheque_number") {
  //   } else {
  //     this.setState({
  //       [e.target.name]: e.target.value,
  //     });
  //   }
  //   console.log("change:", e.target.value);
  // };
  checkform() {
    let errorMsg = {};
    let isValid = true;
    if (!this.state.payment_method) {
      errorMsg["payment_method"] = "Please select payment mode";
      isValid = false;
    }
    if (this.state.payment_method === "C") {
      if (this.state.total_amt == "" || this.state.total_amt == undefined) {
        errorMsg["total_amt"] = "Please enter amount";
        isValid = false;
      } else if (this.state.total_amt == 0) {
        errorMsg["total_amt"] = "Please enter amount grater than Zero";
        isValid = false;
      } else if (this.state.total_amt < 0) {
        errorMsg["total_amt"] = "Please enter amount";
        isValid = false;
      }
      if (this.state.cash_remark == "" || this.state.cash_remark == undefined) {
        errorMsg["cash_remark"] = "Please enter Remark";
        isValid = false;
      }
    }
    if (this.state.payment_method === "Q") {
      if (this.state.fileupload == "" || this.state.fileupload == undefined) {
        errorMsg["cheque_upload"] = "Please Upload Cheque";
        isValid = false;
      }

      if (this.state.cheque_date == "" || this.state.cheque_date == undefined) {
        errorMsg["cheque_date"] = "Please Enter Cheque Date";
        isValid = false;
      }

      if (this.state.issuer_name == "" || this.state.issuer_name == undefined) {
        errorMsg["issuer_name"] = "Please Enter Issuer Name";
        isValid = false;
      }

      if (
        this.state.issuer_remark == "" ||
        this.state.issuer_remark == undefined
      ) {
        errorMsg["issuer_remark"] = "Please Enter Remark";
        isValid = false;
      }

      if (
        this.state.cheque_amount == "" ||
        this.state.cheque_amount == undefined
      ) {
        errorMsg["cheque_amount"] = "Please enter amount";
        isValid = false;
      } else if (this.state.cheque_amount == 0) {
        errorMsg["cheque_amount"] = "Please enter amount grater than Zero";
        isValid = false;
      } else if (this.state.cheque_amount < 0) {
        errorMsg["cheque_amount"] = "Please enter amount";
        isValid = false;
      }

      if (
        this.state.cheque_number == "" ||
        this.state.cheque_number == undefined
      ) {
        errorMsg["cheque_number"] = "Please Enter Cheque Number";
        isValid = false;
      } else if (this.state.cheque_number.length !== 6) {
        errorMsg["cheque_number"] = "Please Enter Valid Cheque Number";
        isValid = false;
      }
    }

    this.setState({
      errorMsg: errorMsg,
    });

    if (isValid) {
      if (this.state.payment_method === "Q") {
        this.setState({ isSpin: true });
        this.uploadcheque();
      } else if (this.state.payment_method === "L") {
        this.qrsms();
      } else {
        this.setState({
          isOpenCollect: false,
          isDisableBtn: false,
          isOpen: true,
        });
      }
    }
  }
  uploadcheque() {
    this.setState({ isOpenCollect: false });
    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    const uid = localStorage.getItem("in_userid");

    const formdata = new FormData();
    formdata.append("file", this.state.fileupload);
    formdata.append(
      "blob_url",
      "cheque_collection_by_cso/" + this.state.fileupload.name
    );
    let generate_Id = generateId(10);
    customFetch(process.env.REACT_APP_URL + "/save/files/bucket", {
      method: "POST",
      body: formdata,
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
            isSpin: false,
          });
        }
        return res.json();
      })
      .then((data) => {
        data = data[0];
        if (data.blob_url) {
          // console.log("in_userid", uid);
          // console.log("household_id", this.state.HH_ID);
          // console.log("cheque_dt", this.state.cheque_date);
          // console.log("amount_collected", this.state.cheque_amount);
          // console.log("cheque_number", this.state.cheque_number);
          // console.log("issuer_name", this.state.issuer_name);
          // console.log("remark", this.state.issuer_remark);
          // console.log("filename", this.state.fileupload);
          const formdata = new FormData();
          formdata.append("in_userid", uid);
          formdata.append("household_id", this.state.household_id);
          formdata.append(
            "cheque_date",
            this.state.cheque_date
            //moment(this.state.cheque_date, "YYYY-MM-DD").format("DD-MM-YYYY")
          );
          formdata.append("amount_collected", this.state.cheque_amount);
          formdata.append("cheque_number", this.state.cheque_number);
          formdata.append("issuer_name", this.state.issuer_name);
          formdata.append("remark", this.state.issuer_remark);
          formdata.append("filename", data.blob_url);
          let generate_Id = generateId(10);
          customFetch(process.env.REACT_APP_URL + "/collection/cheque/set", {
            method: "POST",
            body: formdata,
            headers: {
              "api-token": api_token,
              component_id: generate_Id1,
              apiId: generate_Id,
              api_group_id: "",
              component: this.constructor.name,
              user_id: localStorage.getItem("in_userid"),
            },
          })
            .then((res) => {
              if (res.headers.get("api_code") > 0) {
                this.setState({
                  isErrOpen: true,
                  api_error_message: res.headers.get("api_error_message"),
                  isSpin: false,
                });
              }
              return res.json();
            })
            .then((data) => {
              if (data.document_id) {
                this.props.history.push({
                  pathname: "/collectionSuccess",
                  state: {
                    api_token: api_token,
                    tmp_in_amount_collected: this.state.cheque_amount, //data.tmp_in_amount_collected,
                    tmp_txn_ref_no: data.document_id,
                    Household_name: this.state.issuer_name,
                    message: data.message,
                    payment_method: this.state.payment_method,
                    // tmp_in_charges_collected: data.tmp_in_charges_collected,
                    // tmp_timestamp: data.tmp_timestamp,
                    // OcrAmount: this.state.OcrAmount,
                    // OcrBank: this.state.OcrBank,
                    // OcrDate: this.state.OcrDate,
                    // OcrFrom: this.state.OcrFrom,
                    // OcrTo: this.state.OcrTo,
                    // OcrTransaction_ID: this.state.OcrTransaction_ID,
                    // OcrUPI_UTR_Ref: this.state.refno,
                    // Ocrvendor: this.state.Ocrvendor,
                  },
                });
              } else {
                this.setState({
                  isSpin: false,
                  isErrOpen: true,
                  api_error_message: data.message,
                  cheque_txn_ref_no: data.txn_ref_no,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.setState({
            isSpin: false,
            isErrOpen: true,
            api_error_message: data.message,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  checkDates(event) {
    if (event.target.value == "date") {
      this.state.isDate = true;
      this.state.isDay = false;
      this.state.isMonth = false;
    } else if (event.target.value == "day") {
      this.state.isDate = false;
      this.state.isDay = true;
      this.state.isMonth = false;
    } else {
      this.state.isDate = false;
      this.state.isDay = false;
      this.state.isMonth = true;
    }

    this.forceUpdate();
  }

  getData(event) {
    if (event.target.checked) {
      if (event.target.value) {
        this.state.data_filter = event.target.value;
      }
    }

    this.fetchDetails();

    // console.log(this.state.data_filter);

    // this.state.sort_header = event.target.value;

    // if (event.target.checked) {
    //   this.state.sort_header = event.target.value;
    // }
    // if(filter === "day"){
    //   this.state.isDay = true;
    //   this.state.isDate = false;
    //   this.state.isMonth = false;
    // }
    // this.forceUpdate();
  }

  handleCancelModal = () => {
    this.setState({ isModalOpen: false });
  };
  handleCallSort(event) {
    let temp = this.state.cnames;
    this.state.sort_data = [];

    // console.log(this.state.cnames);

    if (this.state.callsort == 0) {
      if (this.state.notCalledCount > 0) {
        for (let i = 0; i < this.state.cnames.length; i++) {
          let ncd = new Date(this.state.cnames[i].Next_call_dt);
          let calltime = this.state.cnames[i].call_time;

          if (
            this.state.cnames[i].status === "" ||
            this.state.cnames[i].status === null
          ) {
            this.state.sort_data.push(this.state.cnames[i]);
          } else if (this.state.cnames[i].status === 0) {
            if (
              this.state.cnames[i].Preferred_date === "" ||
              this.state.cnames[i].Preferred_date === null
            ) {
              if (
                new Date().getTime() >
                new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.cnames[i].state === 1) {
            if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
              this.state.sort_data.push(this.state.cnames[i]);
            }
          }
        }
        this.state.cnames = this.state.sort_data;
        this.state.callsort = 1;
      } else {
        this.state.cnames = temp;
      }
    } else {
      this.state.cnames = [];
      this.state.callsort = 0;

      for (let i = 0; i < this.state.og_data.length; i++) {
        if (parseFloat(this.state.og_data[i].Balance) > 0) {
          this.state.cnames.push(this.state.og_data[i]);
        }
      }

      if (this.state.counter == 4) {
        if (this.state.temp_array.length > 0) {
          this.state.cnames = [];
          // for (let i = 0; i < this.state.cnames.length; i++) {
          for (let j = 0; j < this.state.temp_array.length; j++) {
            if (this.state.temp_array[j] == "dFilterl0") {
              let notCalledCount = 0;

              for (let i = 0; i < this.state.og_data.length; i++) {
                if (parseFloat(this.state.og_data[i].Balance) < 0) {
                  this.state.sort_data.push(this.state.og_data[i]);

                  let ncd = new Date(this.state.og_data[i].Next_call_dt);
                  let calltime = this.state.og_data[i].call_time;

                  if (
                    this.state.og_data[i].status === "" ||
                    this.state.og_data[i].status === null
                  ) {
                    notCalledCount += 1;
                  } else if (this.state.og_data[i].status === 0) {
                    if (
                      this.state.og_data[i].Preferred_date === "" ||
                      this.state.og_data[i].Preferred_date === null
                    ) {
                      if (
                        new Date().getTime() >
                        new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                      ) {
                        notCalledCount += 1;
                      }
                    }
                  } else if (this.state.og_data[i].state === 1) {
                    if (
                      new Date(calltime).getTime() > new Date(ncd).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                }
              }
              this.state.notCalledCount = notCalledCount;
            } else if (this.state.temp_array[j] == "dFilter0") {
              let notCalledCount = 0;

              for (let i = 0; i < this.state.og_data.length; i++) {
                if (parseFloat(this.state.og_data[i].Balance) == 0) {
                  this.state.sort_data.push(this.state.og_data[i]);
                  if (
                    new Date() > new Date(this.state.og_data[i].Next_call_dt) &&
                    this.state.og_data[i].status == null
                  ) {
                    this.state.og_data[i].isCalled = false;

                    this.state.og_data[i].isCallDetailsAdded = false;

                    notCalledCount += 1;
                  } else if (
                    new Date() > new Date(this.state.og_data[i].Next_call_dt) &&
                    this.state.og_data[i].status != null
                  ) {
                    this.state.og_data[i].isCalled = true;

                    this.state.og_data[i].isCallDetailsAdded = false;
                  } else if (
                    new Date() < new Date(this.state.og_data[i].Next_call_dt)
                  ) {
                    this.state.og_data[i].isCalled = true;

                    this.state.og_data[i].isCallDetailsAdded = true;
                  }
                }
              }
              this.state.notCalledCount = notCalledCount;
            } else if (this.state.temp_array[j] == "dFilter1") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (
                  parseFloat(this.state.og_data[i].Balance) >= 1 &&
                  parseFloat(this.state.og_data[i].Balance) <= 2000
                ) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            } else if (this.state.temp_array[j] == "dFilter2") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (
                  parseFloat(this.state.og_data[i].Balance) >= 2001 &&
                  parseFloat(this.state.og_data[i].Balance) <= 3999
                ) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            } else if (this.state.temp_array[j] == "dFilter3") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (
                  parseFloat(this.state.og_data[i].Balance) >= 4000 &&
                  parseFloat(this.state.og_data[i].Balance) <= 6999
                ) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            } else if (this.state.temp_array[j] == "dFilter4") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (
                  parseFloat(this.state.og_data[i].Balance) >= 7000 &&
                  parseFloat(this.state.og_data[i].Balance) <= 9000
                ) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            } else if (this.state.temp_array[j] == "dFilter5") {
              for (let i = 0; i < this.state.og_data.length; i++) {
                if (parseFloat(this.state.og_data[i].Balance) >= 9001) {
                  this.state.sort_data.push(this.state.og_data[i]);
                }
              }
            }
          }
          // }
          this.state.cnames = this.state.sort_data;
        } else {
          this.state.cnames = this.state.og_data;
        }
      }
    }

    this.forceUpdate();
  }

  fetchDetails() {
    this.setState({ isSpin: true });

    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    let generate_Id = generateId(10);
    let payload = [
      ["Branch_ID", "==", parseInt(localStorage.getItem("branch_id"))],
    ];

    if (
      localStorage.getItem("e_designation_id") ==
      process.env.REACT_APP_EFFECTIVE_DESIGNATION_ID_CSO
    ) {
      payload.push([
        "userid",
        "==",
        parseInt(localStorage.getItem("in_userid")),
      ]);
    }
    customFetch(
      process.env.REACT_APP_URL + "/mongo/get/campaigns/loan_demand_details",
      {
        method: "POST",
        headers: {
          "api-token": api_token,
          component_id: generate_Id1,
          apiId: generate_Id,
          api_group_id: "",
          component: this.constructor.name,
          user_id: localStorage.getItem("in_userid"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
          });
        }
        return res.json();
      })

      .then((json) => {
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          this.props.history.push("/");
        }
        console.log("jsondata", json);

        this.setState({
          isSpin: false,
          isLoaded: true,
          og_data: json,
          cnames: json,
          isReload: false,
        });
      })
      .catch((error) => console.log("error", error));
  }
  componentDidMount() {
    document.title = "Search Household";
    //AT-1659 | AT-1767 | Ankur Makavana | 05-07-2023 | store ui performance data
    setTimeout(() => {
      if (document.readyState === "complete") {
        this.context.onPageLoad({
          component: this.constructor.name,
          component_id: generate_Id1,
        });
      } else {
        window.addEventListener("load", this.context.onPageLoad());
        this.cleanup = () =>
          window.removeEventListener("load", this.context.onPageLoad());
      }
    }, 1000);
    if (checkTime() !== false) {
      this.state.time_flag = 1;
      this.setState({ isSpin: false, maintaenance: checkTime() });
    }
    if (checkBanner() != false) {
      const interval = setInterval(() => {
        this.setState({
          banner_timer: bannertimer(),
        });
      }, 1000);
      this.setState({
        maintaenanceBanner: true,
        maintaenanceBannerText: checkBanner(),
      });
    }
    const { api_token, effective_designation_id } =
      (this.props.location && this.props.location.state) || {};
    // if (
    //   effective_designation_id ==
    //   process.env.REACT_APP_EFFECTIVE_DESIGNATION_ID_CSO
    // ) {
    this.fetchDetails();
    //}
    console.log("Today", moment().format("DD:H"));
    //this.checkTime();
    // this.forceUpdate();
    this.getcollectionmode();
  }
  getcollectionmode() {
    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    let generate_Id = generateId(10);
    customFetch(
      process.env.REACT_APP_URL + "/check/collectionmodeflag/upi/status",
      {
        method: "GET",
        headers: {
          "api-token": api_token,
          component_id: generate_Id1,
          apiId: generate_Id,
          api_group_id: "",
          component: this.constructor.name,
          user_id: localStorage.getItem("in_userid"),
        },
        //   body: formdata,
      }
    )
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
          });
        }
        return res.json();
      })

      .then((json) => {
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          this.props.history.push("/");
        }
        this.setState({
          collectionmode: json,
        });
      })
      .catch((error) => console.log("error", error));
  }
  handleCheckpaymethod(e) {
    this.setState({
      payment_method: e,
      errorMsg: "",
      fileupload: "",
      issuer_name: "",
      cheque_date: "",
      cheque_number: "",
      cheque_amount: "",
      issuer_remark: "",
      total_amt: "",
      totpay: "",
      cash_remark: "",
    });
    if (e != "Q") {
      this.setState({
        isDisablecollection: true,
      });
    } else {
      this.setState({
        isDisablecollection: false,
      });
    }
    if (e === "") {
      this.setState({ fliped: false });
    } else {
      this.setState({ fliped: !this.state.fliped });
    }
  }
  setDateTime = function(date, str) {
    var sp = str.split(":");
    date.setHours(parseFloat(sp[0], 10));
    date.setMinutes(parseFloat(sp[1], 10));
    date.setSeconds(parseFloat(sp[2], 10));
    return date;
  };
  // checkTime() {
  //   var d = new Date();
  //   let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
  //   let mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
  //   var current,
  //     startTime,
  //     currentend,
  //     endTime = "";
  //   if (moment("01/" + mo + "/" + ye).format("ddd") === "Fri") {
  //     current = new Date("01/" + mo + "/" + ye);
  //     startTime = this.setDateTime(new Date(current), "17:30:00");
  //     //currentend = new Date("02/" + mo + "/" + ye);
  //     currentend = new Date("01/" + mo + "/" + ye);
  //     endTime = this.setDateTime(new Date(currentend), "19:00:00");
  //   } else {
  //     current = new Date("02/" + mo + "/" + ye);
  //     startTime = this.setDateTime(new Date(current), "17:30:00");
  //     //currentend = new Date("03/" + mo + "/" + ye);
  //     currentend = new Date("02/" + mo + "/" + ye);
  //     endTime = this.setDateTime(new Date(currentend), "19:00:00");
  //   }
  //   if (d > startTime.getTime() && d < endTime.getTime()) {
  //     this.state.time_flag = 1;
  //     this.setState({ isSpin: false });
  //   } else {
  //     this.state.time_flag = 0;
  //   }
  // }
  handleFilterMenu(event) {
    if (event.currentTarget.id == "nameFilter") {
      this.state.counter = 1;
      this.state.MenuName = "Name";
      this.state.isShowName = true;
      this.state.isShowLoc = false;
      this.state.isShowDem = false;
      this.state.isShowBal = false;
      this.state.isShowCol = false;
    } else if (event.currentTarget.id == "locationFilter") {
      this.state.counter = 2;
      this.state.MenuName = "Location";
      this.state.isShowName = false;
      this.state.isShowLoc = true;
      this.state.isShowDem = false;
      this.state.isShowBal = false;
      this.state.isShowCol = false;
    } else if (event.currentTarget.id == "demandFilter") {
      this.state.counter = 3;
      this.state.MenuName = "Demand";
      this.state.isShowName = false;
      this.state.isShowLoc = false;
      this.state.isShowDem = true;
      this.state.isShowBal = false;
      this.state.isShowCol = false;
    } else if (event.currentTarget.id == "balFilter") {
      this.state.counter = 4;
      this.state.MenuName = "Balance";
      this.state.isShowName = false;
      this.state.isShowLoc = false;
      this.state.isShowDem = false;
      this.state.isShowBal = true;
      this.state.isShowCol = false;
    } else if (event.currentTarget.id == "colFilter") {
      this.state.counter = 5;
      this.state.MenuName = "Collection";
      this.state.isShowName = false;
      this.state.isShowLoc = false;
      this.state.isShowDem = false;
      this.state.isShowBal = false;
      this.state.isShowCol = true;
    }
    this.forceUpdate();
  }
  registerhousehold(hhid) {
    console.log(hhid);
    this.setState({
      isHHReg: true,
      household_id: hhid,
    });
  }
  sendqrsms(
    hhid,
    mobile,
    Balance,
    Charges_OS,
    emi,
    Loan_os,
    hh_name,
    household_number
  ) {
    console.log(hhid);
    //Maximum amount - min(max((balance + Charges_OS), emi), (loan_os + Charges_OS))
    var clc1 = parseFloat(Balance) + parseFloat(Charges_OS);
    var clc2 = parseFloat(Loan_os) + parseFloat(Charges_OS);
    var getmax, getmin;
    if (clc1 > emi) {
      getmax = clc1;
    } else {
      getmax = emi;
    }
    if (clc2 < getmax) {
      getmin = clc2;
    } else {
      getmin = getmax;
    }

    var max_paylink = getmin;
    var totamt = parseFloat(Balance) + parseFloat(Charges_OS);
    if (totamt == 0) {
      this.setState({
        issmsamount: true,
        smsamountErr:
          "You can not send payment link for 0 (zero) amount. Please change the amount.",
      });
    } else {
      this.setState({
        issmsamount: false,
        smsamountErr: "",
      });
    }
    this.setState({
      issendQR: true,
      household_id: hhid,
      smsmobile: mobile,
      totamt: totamt,
      totpay: totamt,
      smsread: true,
      amountread: true,
      max_paylink: max_paylink,
      hh_name: hh_name,
      household_number: household_number,
    });
  }
  qrsms() {
    this.setState({
      issendQR: false,
    });
    const { api_token, household_id } =
      (this.props.location && this.props.location.state) || {};
    /*Check if data is null then logout*/
    var arr = [this.state.household_id, this.state.smsmobile];
    var chkdata = chkapiinput(arr);
    if (chkdata === false) {
      this.setState({ isSpin: false });
      setTimeout(function() {
        logout();
      }, 2000);
    }
    const uid = localStorage.getItem("in_userid");
    const formdata = new FormData();
    formdata.append("household_id", this.state.household_id);
    formdata.append("mobile_no", this.state.smsmobile);
    formdata.append("amount", this.state.totpay);
    formdata.append("created_by_id", uid);
    formdata.append("created_mode", "A");
    let generate_Id = generateId(10);
    customFetch(process.env.REACT_APP_URL + "/create/upi/payment/link", {
      method: "POST",
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
      body: formdata,
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.api_code === 4 || json.api_code === 3 || json.api_code === 5) {
          localStorage.clear();
          this.props.history.push("/");
        }
        console.log(json);

        if (json.short_url) {
          this.setState({
            isSmssent: true,
            smsSentmsg:
              `Payment Link <a href="` +
              json.short_url +
              `"> ` +
              json.short_url +
              ` </a> is Sent Successfully! <br/> अगर यह लिंक ` +
              this.state.Lead_Name +
              ` जी को SMS से प्राप्त नही हुआ है, तभी यह लिंक सिर्फ उनको ही प्रदान करने का कष्ट करे। <b>कृपया यह लिंक दूसरे हाउसहोल्ड को ना भेजें।</b> `,
          });
        } else {
          this.setState({
            isSmssent: true,
            smsSentmsg:
              "Payment Link is Not Sent. Please try again after some time.",
          });
        }
      })
      .catch((error) => console.log("error", error));
  }
  addName(event) {
    if (event.target.checked) {
      this.state.temp_array.push(event.target.id);
      if (event.target.id == "dFilter1") {
        this.state.a2 = 1;
      } else if (event.target.id == "dFilter2") {
        this.state.a3 = 1;
      } else if (event.target.id == "dFilter3") {
        this.state.a4 = 1;
      } else if (event.target.id == "dFilter4") {
        this.state.a5 = 1;
      } else if (event.target.id == "dFilter5") {
        this.state.a6 = 1;
      } else if (event.target.id == "dFilter0") {
        this.state.a0 = 1;
      } else if (event.target.id == "dFilter10") {
        this.state.a1 = 1;
      }

      if (event.target.id == "bFilter1") {
        this.state.b2 = 1;
      } else if (event.target.id == "bFilter2") {
        this.state.b3 = 1;
      } else if (event.target.id == "bFilter3") {
        this.state.b4 = 1;
      } else if (event.target.id == "bFilter4") {
        this.state.b5 = 1;
      } else if (event.target.id == "bFilter5") {
        this.state.b6 = 1;
      } else if (event.target.id == "bFilter0") {
        this.state.b0 = 1;
      } else if (event.target.id == "bFilter10") {
        this.state.b1 = 1;
      }

      if (event.target.id == "cFilter1") {
        this.state.c2 = 1;
      } else if (event.target.id == "cFilter2") {
        this.state.c3 = 1;
      } else if (event.target.id == "cFilter3") {
        this.state.c4 = 1;
      } else if (event.target.id == "cFilter4") {
        this.state.c5 = 1;
      } else if (event.target.id == "cFilter5") {
        this.state.c6 = 1;
      } else if (event.target.id == "cFilter0") {
        this.state.c0 = 1;
      } else if (event.target.id == "cFilter10") {
        this.state.c1 = 1;
      }
    } else {
      for (let i = 0; i < this.state.temp_array.length; i++) {
        if (event.target.id == this.state.temp_array[i]) {
          this.state.temp_array.splice(i, 1);
          if (event.target.id == "dFilter1") {
            this.state.a2 = 0;
          } else if (event.target.id == "dFilter2") {
            this.state.a3 = 0;
          } else if (event.target.id == "dFilter3") {
            this.state.a4 = 0;
          } else if (event.target.id == "dFilter4") {
            this.state.a5 = 0;
          } else if (event.target.id == "dFilter5") {
            this.state.a6 = 0;
          } else if (event.target.id == "dFilter0") {
            this.state.a0 = 0;
          } else if (event.target.id == "dFilter10") {
            this.state.a1 = 0;
          }

          if (event.target.id == "bFilter1") {
            this.state.b2 = 0;
          } else if (event.target.id == "bFilter2") {
            this.state.b3 = 0;
          } else if (event.target.id == "bFilter3") {
            this.state.b4 = 0;
          } else if (event.target.id == "bFilter4") {
            this.state.b5 = 0;
          } else if (event.target.id == "bFilter5") {
            this.state.b6 = 0;
          } else if (event.target.id == "bFilter0") {
            this.state.b0 = 0;
          } else if (event.target.id == "bFilter10") {
            this.state.b1 = 0;
          }

          if (event.target.id == "cFilter1") {
            this.state.c2 = 0;
          } else if (event.target.id == "cFilter2") {
            this.state.c3 = 0;
          } else if (event.target.id == "cFilter3") {
            this.state.c4 = 0;
          } else if (event.target.id == "cFilter4") {
            this.state.c5 = 0;
          } else if (event.target.id == "cFilter5") {
            this.state.c6 = 0;
          } else if (event.target.id == "cFilter0") {
            this.state.c0 = 0;
          } else if (event.target.id == "cFilter10") {
            this.state.c1 = 0;
          }
        }
      }
    }
    console.log(this.state.temp_array);
    this.forceUpdate();
    //
  }

  filter(event) {
    this.state.sort_data = [];

    this.state.cnames = this.state.og_data;

    this.state.callsort = 0;

    if (this.state.counter == 1) {
      if (this.state.temp_array.length > 0) {
        for (let i = 0; i < this.state.cnames.length; i++) {
          for (let j = 0; j < this.state.temp_array.length; j++) {
            if (
              this.state.cnames[i].Lead_Name.toLowerCase().indexOf(
                this.state.temp_array[j].toLowerCase()
              ) == 0
            ) {
              this.state.sort_data.push(this.state.cnames[i]);
            }
          }
        }
        this.state.cnames = this.state.sort_data;
      } else {
        this.state.cnames = this.state.og_data;
      }
    } else if (this.state.counter == 2) {
      if (this.state.temp_array.length > 0) {
        for (let i = 0; i < this.state.cnames.length; i++) {
          for (let j = 0; j < this.state.temp_array.length; j++) {
            if (
              this.state.cnames[i].Location_Name.toLowerCase().indexOf(
                this.state.temp_array[j].toLowerCase()
              ) == 0
            ) {
              this.state.sort_data.push(this.state.cnames[i]);
            }
          }
        }
        this.state.cnames = this.state.sort_data;
      } else {
        this.state.cnames = this.state.og_data;
      }
    } else if (this.state.counter == 3 || this.state.counter == 5) {
      if (this.state.temp_array.length > 0) {
        for (let j = 0; j < this.state.temp_array.length; j++) {
          if (this.state.temp_array[j] == "dFilter1") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) >=
                  0 &&
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) <=
                  2000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter2") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) >=
                  2001 &&
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) <=
                  3999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter3") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) >=
                  4000 &&
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) <=
                  6999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter4") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) >=
                  7000 &&
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) <=
                  9000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter5") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) >=
                9001
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter10") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) <
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "dFilter0") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Demand) +
                  parseFloat(this.state.cnames[i].other_charges_due) ==
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          }

          if (this.state.temp_array[j] == "cFilter1") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) >=
                  0 &&
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) <=
                  2000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter2") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) >=
                  2001 &&
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) <=
                  3999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter3") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) >=
                  4000 &&
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) <=
                  6999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter4") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) >=
                  7000 &&
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) <=
                  9000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter5") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) >=
                9001
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter10") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) <
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          } else if (this.state.temp_array[j] == "cFilter0") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Collected) +
                  parseFloat(this.state.cnames[i].Other_charges_rcvd) ==
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
              }
            }
          }
        }
      } else {
        this.state.cnames = this.state.og_data;
      }
    } else if (this.state.counter == 4) {
      let notCalledCount = 0;
      console.log("Balance");
      if (this.state.temp_array.length > 0) {
        // for (let i = 0; i < this.state.cnames.length; i++) {
        for (let j = 0; j < this.state.temp_array.length; j++) {
          if (this.state.temp_array[j] == "bFilterl0") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) <
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);

                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
            // this.state.notCalledCount = notCalledCount;
          } else if (this.state.temp_array[j] == "bFilter0") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) ==
                0
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
            // this.state.notCalledCount = notCalledCount;
          } else if (this.state.temp_array[j] == "bFilter1") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) >=
                  1 &&
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) <=
                  2000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          } else if (this.state.temp_array[j] == "bFilter2") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) >=
                  2001 &&
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) <=
                  3999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          } else if (this.state.temp_array[j] == "bFilter3") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) >=
                  4000 &&
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) <=
                  6999
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          } else if (this.state.temp_array[j] == "bFilter4") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) >=
                  7000 &&
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) <=
                  9000
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          } else if (this.state.temp_array[j] == "bFilter5") {
            for (let i = 0; i < this.state.cnames.length; i++) {
              if (
                parseFloat(this.state.cnames[i].Balance) +
                  parseFloat(this.state.cnames[i].Charges_OS) >=
                9001
              ) {
                this.state.sort_data.push(this.state.cnames[i]);
                let ncd = new Date(this.state.cnames[i].Next_call_dt);
                let calltime = this.state.cnames[i].call_time;

                if (
                  this.state.cnames[i].status === "" ||
                  this.state.cnames[i].status === null
                ) {
                  notCalledCount += 1;
                } else if (this.state.cnames[i].status === 0) {
                  if (
                    this.state.cnames[i].Preferred_date === "" ||
                    this.state.cnames[i].Preferred_date === null
                  ) {
                    if (
                      new Date().getTime() >
                      new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                    ) {
                      notCalledCount += 1;
                    }
                  }
                } else if (this.state.cnames[i].state === 1) {
                  if (new Date(calltime).getTime() > new Date(ncd).getTime()) {
                    notCalledCount += 1;
                  }
                }
              }
            }
          }
        }
        this.state.notCalledCount = notCalledCount;
        // }
        this.state.cnames = this.state.sort_data;
      } else {
        this.state.cnames = this.state.og_data;
      }
    }

    console.log(this.state.temp_array);
    console.log(this.state.cnames);
    this.forceUpdate();
  }

  handleSearchText(event) {
    this.state.search_text = event.target.value;

    if (this.state.search_text == "") {
      this.state.cnames = [];
      let notCalledCount = 0;
      for (let i = 0; i < this.state.og_data.length; i++) {
        if (parseFloat(this.state.og_data[i].Balance) > 0) {
          this.state.cnames.push(this.state.og_data[i]);
          if (
            new Date() > new Date(this.state.og_data[i].Next_call_dt) &&
            this.state.og_data[i].status == null
          ) {
            this.state.og_data[i].isCalled = false;
            this.state.og_data[i].isCallDetailsAdded = false;
            notCalledCount += 1;
          } else if (
            new Date() > new Date(this.state.og_data[i].Next_call_dt) &&
            this.state.og_data[i].status != null
          ) {
            this.state.og_data[i].isCalled = true;

            this.state.og_data[i].isCallDetailsAdded = false;
          } else if (
            new Date() < new Date(this.state.og_data[i].Next_call_dt)
          ) {
            this.state.og_data[i].isCalled = true;

            this.state.og_data[i].isCallDetailsAdded = true;
          }
        }
      }
      this.state.notCalledCount = notCalledCount;
      this.forceUpdate();
    }
  }

  searchCustomer(event) {
    this.state.sort_data = [];

    this.state.cnames = this.state.og_data;

    for (let i = 0; i < this.state.cnames.length; i++) {
      if (
        this.state.cnames[i].Lead_Name.toLowerCase().indexOf(
          this.state.search_text.toLowerCase()
        ) >= 0 ||
        this.state.cnames[i].Location_Name.toLowerCase().indexOf(
          this.state.search_text.toLowerCase()
        ) >= 0
      ) {
        this.state.sort_data.push(this.state.cnames[i]);
        // console.log();
      }
    }

    this.state.cnames = this.state.sort_data;

    this.forceUpdate();
  }

  handlesort(event) {
    if (this.state.sort_header == "sdemand") {
      if (this.state.sort_htl == "high") {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseFloat(b.Demand) +
              parseFloat(b.other_charges_due) -
              (parseFloat(a.Demand) + parseFloat(a.other_charges_due))
          );

        this.state.cnames = this.state.sort_data;
        // console.log(this.state.sort_data);
        this.forceUpdate();
      } else {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseFloat(a.Demand) +
              parseFloat(a.other_charges_due) -
              (parseFloat(b.Demand) + parseFloat(b.other_charges_due))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      }
    } else if (this.state.sort_header == "sbalanced") {
      if (this.state.sort_htl == "high") {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseFloat(b.Balance) +
              parseFloat(b.Charges_OS) -
              (parseFloat(a.Balance) + parseFloat(a.Charges_OS))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      } else {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseFloat(a.Balance) +
              parseFloat(a.Charges_OS) -
              (parseFloat(b.Balance) + parseFloat(b.Charges_OS))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      }
    } else {
      if (this.state.sort_htl == "high") {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseFloat(b.Collected) +
              parseFloat(b.Other_charges_rcvd) -
              (parseFloat(a.Collected) + parseFloat(a.Other_charges_rcvd))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      } else {
        this.state.sort_data = []
          .concat(this.state.cnames)
          .sort(
            (a, b) =>
              parseFloat(a.Collected) +
              parseFloat(a.Other_charges_rcvd) -
              (parseFloat(b.Collected) + parseFloat(b.Other_charges_rcvd))
          );

        this.state.cnames = this.state.sort_data;
        this.forceUpdate();
      }
    }

    console.log(this.sortModal);
  }

  handlesortdbc(event) {
    this.state.sort_header = event.target.value;

    if (event.target.checked) {
      this.state.sort_header = event.target.value;
    }

    console.log(this.state.sort_header);
  }
  // logout() {
  //   localStorage.clear();
  //   this.props.history.push("/");
  // }

  handlesorthtl(event) {
    this.state.sort_htl = event.target.value;

    if (event.target.checked) {
      this.state.sort_htl = event.target.value;
    }

    // if (this.state.sort_htl == "high") {
    //     if (this.state.sort_header == "sdemand") {
    //         this.state.sort_data = [].concat(this.state.cnames)
    //             .sort((a, b) => b.Demand - a.Demand);

    //         this.state.cnames = this.state.sort_data;
    //     } else if (this.state.sort_header == "sbalanced") {
    //         this.state.sort_data = [].concat(this.state.cnames)
    //             .sort((a, b) => b.Balance - a.Balance);

    //         this.state.cnames = this.state.sort_data;
    //     } else if (this.state.sort_header == "scollected") {
    //         this.state.sort_data = [].concat(this.state.cnames)
    //             .sort((a, b) => b.Collected - a.Collected);

    //         this.state.cnames = this.state.sort_data;
    //     }
    //     this.forceUpdate();
    // } else {
    //     if (this.state.sort_header == "sdemand") {
    //         this.state.sort_data = [].concat(this.state.cnames)
    //             .sort((a, b) => a.Demand - b.Demand);
    //         this.state.cnames = this.state.sort_data;
    //     } else if (this.state.sort_header == "sbalanced") {
    //         this.state.sort_data = [].concat(this.state.cnames)
    //             .sort((a, b) => a.Balance - b.Balance);
    //         this.state.cnames = this.state.sort_data;
    //     } else if (this.state.sort_header == "scollected") {
    //         this.state.sort_data = [].concat(this.state.cnames)
    //             .sort((a, b) => a.Collected - b.Collected);
    //         this.state.cnames = this.state.sort_data;
    //     }
    //     this.forceUpdate();
    // }

    // console.log(this.state.sort_data);
  }

  handleCall = (household_id) => {
    const uid = localStorage.getItem("in_userid");
    // if (!uid) {
    //   this.setState({ isLogout: true, isSpin: false });
    //   return;
    //   // localStorage.clear();
    //   // this.props.history.push("/");
    // }
    /*Check if data is null then logout*/
    var arr = [uid, household_id];
    var chkdata = chkapiinput(arr);
    if (chkdata === false) {
      this.setState({ isSpin: false });
      setTimeout(function() {
        logout();
      }, 2000);
    }
    const formdata = new FormData();
    formdata.append("in_userid", uid);
    formdata.append("household_id", household_id);

    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    let generate_Id = generateId(10);
    customFetch(process.env.REACT_APP_URL + "/save/cso/call/details", {
      method: "POST",
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
      body: formdata,
    })
      .then(() => {
        this.fetchDetails();
      })
      .catch((error) => console.log("error", error));
    this.forceUpdate();
  };
  chkTotalamt = (e) => {
    this.setState({
      total_amt: e.target.value.replace(/\D/, ""),
    });
    if (e.target.value.replace(/\D/, "")) {
      this.setState({ isDisablecollection: false });
    } else {
      this.setState({ isDisablecollection: true });
    }
  };
  chkTotal = (e) => {
    console.log("amount:", e.target.value);
    var pattern = new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/g);
    if (e.target.name == "totpay") {
      this.setState({ totpay: e.target.value.replace(/[^\d.-]/g, "") });
      //var pattern = new RegExp(/^(?!0\.00)\d{1,3}(\d{3})*(\.\d\d)?$/gm);
      if (!pattern.test(e.target.value.replace(/[^\d.-]/g, ""))) {
        this.setState({
          smsamountErr: "Please Enter Valid Amount",
          issmsamount: true,
          isDisablecollection: true,
        });
      } else if (parseFloat(e.target.value.replace(/[^\d.-]/g, "")) > 99999) {
        this.setState({
          issmsamount: true,
          isDisablecollection: true,
          smsamountErr:
            "आप इस हाउसहोल्ड के लिए 99999" +
            ' से अधिक कलेक्शन नहीं कर सकते। ज्यादा जानकारी के लिए WhatsApp में <a href="https://chat.whatsapp.com/K1kzdBQHwhoLk3u8LtxApZ"> AceN Assist Group </a> में मैसेज करिये। ',
        });
      } else if (e.target.value == 0) {
        this.setState({
          issmsamount: true,
          isDisablecollection: true,
          smsamountErr: "Amount can not be 0 (zero)",
        });
      } else {
        this.setState({
          issmsamount: false,
          smsamountErr: "",
          isDisablecollection: false,
        });
      }
    }

    if (e.target.name == "cheque_amount") {
      this.setState({ cheque_amount: e.target.value.replace(/[^\d.-]/g, "") });
      //var pattern = new RegExp(/^(?!0\.00)\d{1,3}(\d{3})*(\.\d\d)?$/gm);
      if (!pattern.test(e.target.value.replace(/[^\d.-]/g, ""))) {
        this.setState({
          chequeamountErr: "Please Enter Valid Amount",
          ischequeamount: true,
          isDisablecollection: true,
        });
      } else {
        this.setState({
          chequeamountErr: "",
          ischequeamount: false,
          isDisablecollection: false,
        });
      }
    }
  };
  chksmsmob = (e) => {
    console.log("chkmob:", e.target.value);
    this.setState({ smsmobile: e.target.value.replace(/\D/g, "") });
    if (e.target.value.replace(/\D/g, "").length != 10) {
      //isValid = false;
      this.setState({
        smsmobileErr: "Please Enter Valid Mobile Number",
        isDisablecollection: true,
      });
      //errors["Mobilenumber"] = "Please enter valid  Mobile Number.";
    } else {
      this.setState({ smsmobileErr: "", isDisablecollection: false });
    }
  };
  chkaltmob = (e) => {
    console.log("chkmob:", e.target.value);
    this.setState({
      alternate_mobile_number: e.target.value.replace(/\D/g, ""),
    });
    if (e.target.value && e.target.value.replace(/\D/g, "").length != 10) {
      //isValid = false;
      this.setState({
        altmobileErr: "Please Enter Valid Mobile Number",
        isDisablecollection: true,
      });
      //errors["Mobilenumber"] = "Please enter valid  Mobile Number.";
    } else {
      this.setState({ altmobileErr: "", isDisablecollection: false });
    }
  };
  handleSubmit = () => {
    //event.preventDefault();
    if (navigator.onLine) {
      this.setState({ isDisable: true, isDisableBtn: true, isSpin: true });
      const uid = localStorage.getItem("in_userid");
      if (!uid) {
        this.setState({ isLogout: true, isSpin: false, isOpen: false });
        return;
        // localStorage.clear();
        // this.props.history.push("/");
      }
      const { api_token, hh_id, Borrower_Name, household_id } =
        (this.props.location && this.props.location.state) || {};
      if (uid) {
        /*Check if data is null then logout*/
        // var arr = [
        //   hh_id,
        //   this.state.isBalanceZero
        //     ? parseFloat(this.state.Loan_os)
        //     : this.state.totalAmt,
        //   this.state.isBalanceZero ? this.state.Charges_OS : this.state.charges,
        //   this.state.payment_method,
        //   uid,
        // ];
        // console.log("arr", arr);
        // var chkdata = chkapiinput(arr);
        // if (chkdata === false) {
        //   this.setState({ isSpin: false });
        //   setTimeout(function () {
        //     logout();
        //   }, 2000);
        // }
        const formdata = new FormData();
        formdata.append("in_household_id", this.state.household_id);
        formdata.append(
          "in_amount_collected",
          // this.state.isBalanceZero
          //   ? parseFloat(this.state.Loan_os)
          //   : this.state.totalAmt
          this.state.total_amt
        );
        formdata.append("in_charges_collected", this.state.Charges_OS);
        formdata.append("in_collection_mode_flag", "C (Cash)"); //this.state.payment_method
        // in_reference_number,in_remark,in_frontend_file_name use for upi or comes from ocr read for UPI
        formdata.append("in_reference_number", "");
        // if (this.state.OcrTransaction_ID) {
        //   formdata.append(
        //     "in_remark",
        //     this.state.remark + "_" + this.state.OcrTransaction_ID
        //   );
        // } else {
        //   formdata.append("in_remark", this.state.remark);
        // }
        formdata.append("in_remark", this.state.cash_remark);
        formdata.append("in_frontend_file_name", "");
        formdata.append("in_userid", uid);
        formdata.append("in_collection_type", "P");
        formdata.append("flag", this.state.partner_flag);
        formdata.append("product_id", this.state.product_id);
        formdata.append("branch_id", this.state.Branch_ID);
        formdata.append(
          "alternate_mobile_number",
          this.state.alternate_mobile_number || ""
        );
        let generate_Id = generateId(10);
        const requestOptions = {
          method: "POST",
          headers: {
            "api-token": api_token,
            component_id: generate_Id1,
            apiId: generate_Id,
            api_group_id: "",
            component: this.constructor.name,
            user_id: localStorage.getItem("in_userid"),
          },
          body: formdata,
        };

        // for (const value of formdata.values()) {
        //   console.log(value);
        // }
        customFetch(
          process.env.REACT_APP_URL + "/set/collection/household/customer_new",
          requestOptions
        )
          .then((response) => {
            if (response.headers.get("api_code") > 0) {
              this.setState({
                isErrOpen: true,
                api_error_message: response.headers.get("api_error_message"),
                isSpin: false,
                isOpen: false,
                isReload: true,
              });
            }
            return response.json();
          })
          .then((data) => {
            console.log(data);
            if (
              data.api_code === 4 ||
              data.api_code === 3 ||
              data.api_code === 5
            ) {
              localStorage.clear();
              this.props.history.push("/");
            }
            if (data.txn_ref_no) {
              this.props.history.push({
                pathname: "/collectionSuccess",
                state: {
                  api_token: api_token,
                  tmp_in_amount_collected: this.state.total_amt, //data.tmp_in_amount_collected,
                  tmp_in_charges_collected: data.tmp_in_charges_collected,
                  tmp_timestamp: data.tmp_timestamp,
                  tmp_txn_ref_no: data.txn_ref_no,
                  payment_method: this.state.payment_method,
                  Household_name: this.state.Lead_Name,
                  OcrAmount: this.state.OcrAmount,
                  OcrBank: this.state.OcrBank,
                  OcrDate: this.state.OcrDate,
                  OcrFrom: this.state.OcrFrom,
                  OcrTo: this.state.OcrTo,
                  OcrTransaction_ID: this.state.OcrTransaction_ID,
                  OcrUPI_UTR_Ref: this.state.refno,
                  Ocrvendor: this.state.Ocrvendor,
                  message: data.message,
                },
              });
            } else {
              this.setState({
                isErrOpen: true,
                api_error_message: data.message,
                isSpin: false,
                isOpen: false,
                isDisable: false,
              });
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        this.setState({
          isErrOpen: true,
          api_error_message: "Please Contact Helpdesk",
          isSpin: false,
        });
      }
    } else {
      this.setState({
        isOffline: true,
        isOpen: false,
        isSpin: false,
      });
    }
  };
  chequeOCR(e) {
    e.preventDefault();
    console.log("file", e.target.files[0]);
    this.setState({
      fileupload: e.target.files[0],
    });

    const { api_token } =
      (this.props.location && this.props.location.state) || {};
    const formdata = new FormData();
    formdata.append("file", e.target.files[0]);
    let generate_Id = generateId(10);
    customFetch(process.env.REACT_APP_URL + "/get/cheque/details", {
      method: "POST",
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
      body: formdata,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        console.log("Cheque:", data.data[0].chq_date);
        this.setState({
          cheque_amount: data.data[0].chq_amount,
          cheque_date: data.data[0].chq_date
            ? moment(data.data[0].chq_date, "DD-MM-YYYY").format("YYYY-MM-DD")
            : "",
          cheque_number: data.data[0].chq_no,
          issuer_name: data.data[0].name_of_issuer,
        });
      })
      .catch((error) => console.log("error", error));
  }
  handlePageChange = (page, pageSize) => {
    this.setState({ currentPage: page, pageSize: pageSize });
  };
  render() {
    const { api_token, effective_designation_id } =
      (this.props.location && this.props.location.state) || {};
    const uid = localStorage.getItem("in_userid");
    // console.log(
    //   "chq_amount",
    //   this.state.chequeOCRdata && this.state.chequeOCRdata.chq_amount
    // );

    let data = this.state.items;
    const {
      isErrOpen,
      api_error_message,
      isHHReg,
      issendQR,
      isSmssent,
      smsSentmsg,
      errorMsg,
      isOpen,
      cnames,
      currentPage,
      pageSize,
    } = this.state;

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedItems = cnames.slice(startIndex, endIndex);
    // if (temp.length > 0) {
    //   console.log(data.Branches);

    // }

    // let cnames = this.state.cnames;

    // let cnames = this.state.cnames;

    if (this.state.cnames.length > 0) {
      this.state.cnames.map((item) => {
        var findItem = this.state.uniqueNames.find(
          (x) => x.indexOf(item.Lead_Name.split(" ")[0]) == 0
        );
        if (!findItem)
          this.state.uniqueNames.push(item.Lead_Name.split(" ")[0]);
      });

      this.state.uniqueNames = this.state.uniqueNames.sort((a, b) =>
        a.localeCompare(b)
      );
    }
    console.log("this.state.cnames", this.state.cnames);
    return (
      <>
        {this.state.isSpin ? (
          <div class="preloader">
            <div class="loader" ng-hide="data.length > 0"></div>
          </div>
        ) : (
          ""
        )}
        <div
          className={
            isOpen
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content pt-confirm-box col-sm-12">
              <span className="cb-cname">Household Name</span>

              <div className="cb-cname-box">{this.state.Lead_Name}</div>
              <span className="cb-cname">Household ID</span>

              <div className="cb-cname-box">{this.state.HH_ID}</div>
              <div className="emiCharge">
                <div>
                  <span className="cb-cname">Total Amount</span>
                  <div className="cb-cname-box">
                    {"Rs. " + this.state.total_amt}

                    {/* Rs. {parseFloat(this.state.totsum)} */}
                  </div>
                  <div>
                    <label className="cb-cname">Current Dues:</label>
                    <div>
                      <span className="emi-left">
                        [ Amount{" "}
                        <img src={require("../assets/images/rupee.png")} />{" "}
                        {parseFloat(this.state.Balance).toLocaleString("en-IN")}
                        {/* {parseFloat(this.state.totalAmt)} */}
                      </span>
                      <span className="emi-right">
                        {" "}
                        Charges{" "}
                        <img src={require("../assets/images/rupee.png")} />{" "}
                        {parseFloat(this.state.Charges_OS).toLocaleString(
                          "en-IN"
                        )}
                        {/* {parseFloat(this.state.charges)} */}]
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cb-buttons">
                <div className="col-sm-6">
                  <button
                    className="btn btn-primary btn-lg btn-block rbtn"
                    onClick={() => {
                      this.handleSubmit();
                    }}
                    //disabled={isDisableBtn}
                  >
                    Confirm
                  </button>
                </div>
                <div className="col-sm-6">
                  <button
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.setState({ isOpen: false })}
                    className="btn btn-primary btn-lg btn-block rbtn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            this.state.isOpenCollect
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div
            className={
              this.state.fliped
                ? "modal-dialog modal-lg flipped"
                : "modal-dialog modal-lg"
            }
          >
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className={
                  this.state.fliped === true
                    ? "close text-left"
                    : "close text-right"
                }
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isOpenCollect: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              {this.state.fliped === true && (
                <button
                  type="button"
                  className="close text-right"
                  onClick={() => this.setState({ fliped: !this.state.fliped })}
                >
                  <span aria-hidden="true">
                    <img
                      src={require("../assets/images/back.png")}
                      className="icon_popup_back"
                    />
                  </span>
                </button>
              )}
              <div className="row text-center">
                {this.state.fliped === false ? (
                  <div className="col-sm-12">
                    <div className="pthtext2">
                      <span className="bluetext">Select Payment Mode</span>
                    </div>
                    <select
                      //className="form-control rinput"
                      className="form-control rinput"
                      name="payment_method"
                      onChange={(e) => {
                        this.handleCheckpaymethod(e.target.value);
                      }}
                      value={this.state.payment_method}
                    >
                      <option value="">Select Collection Mode</option>
                      {this.state.collectionmode &&
                        this.state.collectionmode.map((modeflag) => {
                          if (modeflag.collection_mode_flag == "C") {
                            return (
                              <option value={modeflag.collection_mode_flag}>
                                {modeflag.collection_mode_name}
                              </option>
                            );
                          }
                        })}
                    </select>
                    <span className="errmsg">{errorMsg.payment_method}</span>
                  </div>
                ) : (
                  ""
                )}
                {this.state.payment_method === "C" && (
                  <>
                    {this.state.fliped === true ? (
                      <>
                        <div
                          className={
                            this.state.fliped === true
                              ? "col-sm-12 back"
                              : "col-sm-12"
                          }
                        >
                          <div className="pthtext2">
                            <span for="inputEmail4" className="bluetext">
                              Total Amount (Including Charges)
                            </span>
                          </div>
                          <input
                            className="form-control rinput"
                            id="inputEmail4"
                            name="total_amt"
                            pattern="[0-9.]*"
                            value={this.state.total_amt}
                            onChange={this.chkTotalamt}
                            //onChange={this.chkTotal}
                          />
                          <span className="errmsg">{errorMsg.total_amt}</span>
                          <span className="errmsg">
                            {this.state.cashamountErr}
                          </span>
                        </div>
                        <div
                          className={
                            this.state.fliped === true
                              ? "col-sm-12 back"
                              : "col-sm-12"
                          }
                        >
                          <div className="pthtext2">
                            <span for="inputEmail4" className="bluetext">
                              Remark
                            </span>
                          </div>
                          <textarea
                            className="form-control rinput"
                            rows="2"
                            onChange={(e) =>
                              this.setState({
                                cash_remark: e.target.value,
                                isDisablecollection: false,
                              })
                            }
                            value={this.state.cash_remark}
                            name="cash_remark"
                          ></textarea>
                          <span className="errmsg">{errorMsg.cash_remark}</span>
                        </div>
                        <div
                          className={
                            this.state.fliped === true
                              ? "col-sm-12 back"
                              : "col-sm-12"
                          }
                        >
                          <div className="pthtext2">
                            <span className="extmobno">
                              Existing Mobile No: {this.state.smsmobile}
                            </span>
                            <span for="inputEmail4" className="bluetext">
                              Alternate Mobile Number
                            </span>
                          </div>
                          {/* <input
                            className="form-control"
                            name="alternate_mobile_number"
                            onChange={(e) =>
                              this.setState({
                                alternate_mobile_number: e.target.value.replace(
                                  /\D/g,
                                  ""
                                ),
                                isDisablecollection: false,
                              })
                            }
                            value={this.state.alternate_mobile_number}
                          /> */}
                          <input
                            className="form-control"
                            name="alternate_mobile_number"
                            value={this.state.alternate_mobile_number}
                            readOnly={this.state.altmobread}
                            onChange={this.chkaltmob}
                          />
                          <img
                            src={require("../assets/images/edit.png")}
                            className="altmobedt"
                            onClick={(e) =>
                              this.setState({ altmobread: false })
                            }
                          />
                          <span className="errmsg">
                            {this.state.altmobileErr}
                          </span>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {this.state.payment_method === "Q" && (
                  <>
                    {this.state.fliped === true ? (
                      <div
                        className={
                          this.state.fliped === true
                            ? "col-sm-12 back"
                            : "col-sm-12"
                        }
                      >
                        <div className="pthtext2 text-center">
                          <span for="inputEmail4" className="bluetext">
                            Upload Cheque
                          </span>
                        </div>
                        <div className="cheque-upload">
                          <img
                            src={require("../assets/images/upload-big-arrow.png")}
                            primary={false}
                            onClick={() => {
                              this.upload.click();
                            }}
                          />
                          <input
                            type="file"
                            name="file"
                            onChange={(e) => this.chequeOCR(e)}
                            accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG"
                            //onChange={this.ImgchangeHandler.bind(this)}
                            ref={(ref) => (this.upload = ref)}
                            style={{ display: "none" }}
                          />
                        </div>
                        <span className="errmsg">
                          {!this.state.fileupload && errorMsg.cheque_upload}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.fileupload ? (
                      this.state.fliped === true ? (
                        <>
                          <div
                            className={
                              this.state.fliped === true
                                ? "col-sm-6 mt-3 back"
                                : "col-sm-6 mt-3"
                            }
                          >
                            <span className="bluetext">Cheque date</span>
                            <input
                              type="date"
                              value={this.state.cheque_date}
                              name="cheque_date"
                              onChange={(e) =>
                                this.setState({
                                  cheque_date: e.target.value,
                                  isDisablecollection: false,
                                })
                              }
                              className="form-control rinput"
                            />
                            <span className="errmsg">
                              {!this.state.cheque_date && errorMsg.cheque_date}
                            </span>
                          </div>
                          <div
                            className={
                              this.state.fliped === true
                                ? "col-sm-6 mt-3 back"
                                : "col-sm-6 mt-3"
                            }
                          >
                            <div class="form-group">
                              <span className="bluetext">
                                Name of the issuer
                              </span>
                              <input
                                type="text"
                                value={this.state.issuer_name}
                                name="issuer_name"
                                onChange={(e) =>
                                  this.setState({
                                    issuer_name: e.target.value,
                                    isDisablecollection: false,
                                  })
                                }
                                className="form-control rinput"
                              />
                              <span className="errmsg">
                                {!this.state.issuer_name &&
                                  errorMsg.issuer_name}
                              </span>
                            </div>
                          </div>

                          <div
                            className={
                              this.state.fliped === true
                                ? "col-sm-6 back"
                                : "col-sm-6"
                            }
                          >
                            <span className="bluetext">Amount</span>
                            <input
                              type="text"
                              value={this.state.cheque_amount}
                              name="cheque_amount"
                              pattern="[0-9.]*"
                              //onChange={this.handleChange}
                              onChange={this.chkTotal}
                              // onChange={(e) =>
                              //   this.setState({
                              //     cheque_amount: e.target.value,
                              //   })
                              // }
                              className="form-control rinput"
                            />
                            <span className="errmsg">
                              {!this.state.cheque_amount &&
                                errorMsg.cheque_amount}
                            </span>
                            <span className="errmsg">
                              {this.state.chequeamountErr}
                            </span>
                          </div>
                          <div
                            className={
                              this.state.fliped === true
                                ? "col-sm-6 back"
                                : "col-sm-6"
                            }
                          >
                            <span className="bluetext">Cheque Number</span>
                            <input
                              type="text"
                              value={this.state.cheque_number}
                              name="cheque_number"
                              //onChange={this.handleChange}
                              max={6}
                              pattern="[0-9.]*"
                              onChange={(e) =>
                                this.setState({
                                  cheque_number: e.target.value.replace(
                                    /\D/,
                                    ""
                                  ),
                                  isDisablecollection: false,
                                })
                              }
                              className="form-control rinput"
                            />
                            <span className="errmsg">
                              {!this.state.cheque_number &&
                                errorMsg.cheque_number}
                            </span>
                          </div>
                          <div
                            className={
                              this.state.fliped === true
                                ? "col-sm-12 back"
                                : "col-sm-12"
                            }
                          >
                            <span className="bluetext">Remark </span>
                            <textarea
                              className="form-control rinput"
                              rows="2"
                              onChange={(e) =>
                                this.setState({
                                  issuer_remark: e.target.value,
                                  isDisablecollection: false,
                                })
                              }
                              value={this.state.issuer_remark}
                              name="issuer_remark"
                            ></textarea>
                            <span className="errmsg">
                              {!this.state.issuer_remark &&
                                errorMsg.issuer_remark}
                            </span>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </>
                )}
                {this.state.payment_method === "L" && (
                  <>
                    {this.state.fliped === true ? (
                      <div
                        className={
                          this.state.fliped === true
                            ? "col-sm-12 back"
                            : "col-sm-12"
                        }
                      >
                        <p className="PayLinkLabel">
                          Do you want to send Payment link to customer?
                        </p>
                        <div>
                          <div className="row mb-2">
                            <div className="col-6">
                              <label className="PayLinkLabel">Phone No.</label>
                              <input
                                className="form-control"
                                name="smsmobile"
                                value={this.state.smsmobile}
                                readOnly={this.state.smsread}
                                onChange={this.chksmsmob}
                              />
                              <img
                                src={require("../assets/images/edit.png")}
                                className="smsmobedt"
                                onClick={(e) =>
                                  this.setState({ smsread: false })
                                }
                              />
                            </div>
                            <div className="col-6">
                              <label className="PayLinkLabel">Amount</label>
                              <input
                                className="form-control"
                                name="totpay"
                                value={this.state.totpay}
                                onChange={this.chkTotal}
                              />
                            </div>
                            {/* <div className="col-2 unique-name-click">
                  </div> */}
                            <div className="col-md-12 errmsg">
                              {this.state.smsmobileErr}
                            </div>

                            {/* <div className="col-2">Amount</div> */}

                            {/* <div className="col-2 unique-name-click">
                  </div> */}
                            <div className="col-md-12 errmsg">
                              {this.state.smsamountErr ? (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.smsamountErr,
                                  }}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                )}
                <div className="col-sm-12 text-center mt-3">
                  {this.state.payment_method && (
                    <button
                      className={
                        this.state.fliped === true
                          ? "btn btn-primary back"
                          : "btn btn-primary"
                      }
                      disabled={this.state.isDisablecollection}
                      // className="btn btn-primary"
                      onClick={() => {
                        this.setState({
                          isDisablecollection: true,
                          //isOpenCollect: false,
                        });
                        this.checkform();
                      }}
                    >
                      {this.state.payment_method == "C"
                        ? "Collect Cash"
                        : this.state.payment_method == "Q"
                        ? "Collect Cheque"
                        : this.state.payment_method == "L" && "Send Link"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            isErrOpen
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  this.setState({ isErrOpen: false });
                  {
                    this.state.isReload && this.fetchDetails();
                  }
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>{api_error_message}</p>
              {this.state.cheque_txn_ref_no && (
                <p>Ref. Number : {this.state.cheque_txn_ref_no}</p>
              )}
            </div>
          </div>
        </div>
        <div
          className={
            this.state.isLogout
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => logout(null, null, true)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>We Have to Log You Out. Kindly Login again</p>
            </div>
          </div>
        </div>
        <div
          className={
            isSmssent
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isSmssent: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p
                dangerouslySetInnerHTML={{
                  __html: smsSentmsg,
                }}
              />
            </div>
          </div>
        </div>
        <div
          className={
            isHHReg
              ? "modal fade bd-example-modal-sm show mymodal"
              : "modal fade bd-example-modal-sm"
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="confirm-box"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.setState({ isHHReg: false })}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p>Do you want to register the household for NACH?</p>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/Nach_type",
                      state: {
                        api_token: api_token,
                        household_id: this.state.household_id,
                      },
                    });
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => this.setState({ isHHReg: false })}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade bd-example-modal-sm"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="sort-filter"
          ref={this.sortModal}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content sort_block col-sm-12">
              <span className="bluetext-header-sort">SORT BY</span>
              <table className="table">
                {/* <thead>
                                    <tr>
                                        <th colSpan="2"></th>
                                    </tr>
                                </thead> */}
                <tbody>
                  <tr>
                    <td>Demand</td>
                    <td>
                      <input
                        type="radio"
                        className="form-check-input"
                        value="sdemand"
                        name="sortmenu"
                        onChange={this.handlesortdbc}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Balance</td>
                    <td>
                      <input
                        type="radio"
                        className="form-check-input"
                        value="sbalanced"
                        name="sortmenu"
                        onChange={this.handlesortdbc}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Collected</td>
                    <td>
                      <input
                        type="radio"
                        className="form-check-input"
                        value="scollected"
                        name="sortmenu"
                        onChange={this.handlesortdbc}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="sortBlueBox">
                <div>
                  <input
                    type="radio"
                    id="htl"
                    name="htl"
                    value="high"
                    onChange={this.handlesorthtl}
                  />
                  <label htmlFor="high">&nbsp;High To Low</label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="htl"
                    name="htl"
                    onChange={this.handlesorthtl}
                    value="low"
                  />
                  <label htmlFor="low">&nbsp;Low To High</label>
                </div>
              </div>
              <button
                data-dismiss="modal"
                type="button"
                className="btn btn-primary btn-lg btn-block rbtn search_elements"
                onClick={this.handlesort}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="filter"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="filter_window">
                <div className="filter_header">
                  <table className="table filter-table">
                    <thead>
                      <tr>
                        <th>Filter</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        onClick={this.handleFilterMenu}
                        id="nameFilter"
                        className="unique-name-click"
                      >
                        <td>Name</td>
                      </tr>

                      <tr
                        onClick={this.handleFilterMenu}
                        id="locationFilter"
                        className="unique-name-click"
                      >
                        <td>Location</td>
                      </tr>
                      <tr
                        onClick={this.handleFilterMenu}
                        id="demandFilter"
                        className="unique-name-click"
                      >
                        <td>Demand</td>
                      </tr>
                      <tr
                        onClick={this.handleFilterMenu}
                        id="balFilter"
                        className="unique-name-click"
                      >
                        <td>Balance</td>
                      </tr>
                      <tr
                        onClick={this.handleFilterMenu}
                        id="colFilter"
                        className="unique-name-click"
                      >
                        <td>Collection</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="filter_amt" id="filter-sub-menu">
                  {this.state.isShowName && (
                    <div className="unique-names" id="uniqueNameDiv">
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>
                      <table className="table table-borderless">
                        {this.state.uniqueNames.map((item, key) => (
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <input
                                  type="checkbox"
                                  id={item}
                                  name={item}
                                  onChange={this.addName}
                                />
                                <label htmlFor="vehicle1"> &nbsp; {item}</label>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </table>
                    </div>
                  )}

                  {this.state.isShowLoc && (
                    <div className="unique-names">
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>

                      <table className="table table-borderless">
                        {this.state.uniqueLocation.length > 0 ? (
                          this.state.uniqueLocation.map((item, key) => (
                            <tbody>
                              <tr>
                                <td>
                                  {" "}
                                  <input
                                    type="checkbox"
                                    id={item}
                                    name={item}
                                    onChange={this.addName}
                                  />
                                  <label htmlFor="vehicle1">
                                    {" "}
                                    &nbsp; {item}
                                  </label>
                                </td>
                              </tr>
                            </tbody>
                          ))
                        ) : (
                          <tbody>
                            <tr>
                              <td>No Location</td>
                            </tr>
                          </tbody>
                        )}
                      </table>
                    </div>
                  )}
                  {this.state.isShowDem && (
                    <>
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilterl0"
                                name="dFilterl0"
                                onChange={this.addName}
                                defaultChecked={this.state.a0}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Less Than 0
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter0"
                                name="dFilter0"
                                onChange={this.addName}
                                defaultChecked={this.state.a1}
                              />
                              <label htmlFor="vehicle1"> &nbsp; Rs. 0 </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter1"
                                name="dFilter1"
                                onChange={this.addName}
                                defaultChecked={this.state.a2}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Rs. 1 - Rs. 2000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter2"
                                name="dFilter2"
                                onChange={this.addName}
                                defaultChecked={this.state.a3}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp;Rs. 2001 - Rs. 3999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter3"
                                name="dfilter3"
                                onChange={this.addName}
                                defaultChecked={this.state.a4}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 4000 - Rs. 6999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter4"
                                name="dFilter4"
                                onChange={this.addName}
                                defaultChecked={this.state.a5}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 7000 - Rs. 9000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="dFilter5"
                                name="dFilter5"
                                onChange={this.addName}
                                defaultChecked={this.state.a6}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 9001 - Above
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}

                  {this.state.isShowBal && (
                    <>
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilterl0"
                                name="bFilterl0"
                                onChange={this.addName}
                                defaultChecked={this.state.b0}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Less Than 0
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter0"
                                name="bFilter0"
                                onChange={this.addName}
                                defaultChecked={this.state.b1}
                              />
                              <label htmlFor="vehicle1"> &nbsp; Rs. 0 </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter1"
                                name="bFilter1"
                                onChange={this.addName}
                                defaultChecked={this.state.b2}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Rs. 1 - Rs. 2000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter2"
                                name="bFilter2"
                                onChange={this.addName}
                                defaultChecked={this.state.b3}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp;Rs. 2001 - Rs. 3999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter3"
                                name="bFilter3"
                                onChange={this.addName}
                                defaultChecked={this.state.b4}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 4000 - Rs. 6999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter4"
                                name="bFilter4"
                                onChange={this.addName}
                                defaultChecked={this.state.b5}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 7000 - Rs. 9000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="bFilter5"
                                name="bFilter5"
                                onChange={this.addName}
                                defaultChecked={this.state.b6}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 9001 - Above
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}

                  {this.state.isShowCol && (
                    <>
                      <center>
                        <strong>{this.state.MenuName}</strong>
                      </center>
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilterl0"
                                name="cFilterl0"
                                onChange={this.addName}
                                defaultChecked={this.state.c0}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Less Than 0
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter0"
                                name="cFilter0"
                                onChange={this.addName}
                                defaultChecked={this.state.c1}
                              />
                              <label htmlFor="vehicle1"> &nbsp; Rs. 0 </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter1"
                                name="cFilter1"
                                onChange={this.addName}
                                defaultChecked={this.state.c2}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp; Rs. 1 - Rs. 2000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter2"
                                name="cFilter2"
                                onChange={this.addName}
                                defaultChecked={this.state.c3}
                              />
                              <label htmlFor="vehicle1">
                                {" "}
                                &nbsp;Rs. 2001 - Rs. 3999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter3"
                                name="cFilter3"
                                onChange={this.addName}
                                defaultChecked={this.state.c4}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 4000 - Rs. 6999
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter4"
                                name="cFilter4"
                                onChange={this.addName}
                                defaultChecked={this.state.c5}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 7000 - Rs. 9000
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="checkbox"
                                id="cFilter5"
                                name="cFilter5"
                                onChange={this.addName}
                                defaultChecked={this.state.c6}
                              />
                              <label htmlFor="vehicle1">
                                &nbsp; Rs. 9001 - Above
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                  <div className="filter-btn-div">
                    <button
                      data-dismiss="modal"
                      className="btn btn-primary btn-block btn-lg rbtn"
                      onClick={this.filter}
                    >
                      APPLY
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade bd-example-modal-sm"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="search"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content search_block col-sm-12">
              {/* <form onSubmit={this.searchCustomer}> */}

              <input
                type="text"
                className="form-control rinput1 search_elements1"
                id="sfname"
                name="sfname"
                placeholder="Enter First Name or Location or Household ID"
                required
                onChange={this.handleSearchText}
              />
              <button
                data-dismiss="modal"
                onClick={this.searchCustomer}
                type="submit"
                className="btn btn-primary btn-lg btn-block rbtn search_elements"
              >
                Search
              </button>
              {/* </form> */}
            </div>
          </div>
        </div>

        <div className="container">
          <div className="top_nav">
            <a>
              <div
                className="icon_bg"
                onClick={() => this.props.history.goBack()}
              >
                <img
                  src={require("../assets/images/back.png")}
                  className="icon_img"
                />
              </div>
            </a>
            <span className="head-title">Search Household</span>

            <a>
              <div className="log-out-deposit">
                <img
                  src={require("../assets/images/power-off.png")}
                  onClick={() => logout(null, null, true)}
                  alt=""
                />
              </div>
            </a>
          </div>
          {this.state.time_flag == 1 ? (
            <div className="maintaenance-container">
              <div className="maintaenance-image">
                <img src="data:image/gif;base64,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" />
              </div>
              <br />
              <div class="content">
                <h3>
                  <span className="maintaenance-text">
                    {" "}
                    Maintenance in progress.
                    <br />
                    <p>{this.state.maintaenance}</p>
                  </span>
                </h3>
                <p>Please stand by</p>
              </div>
            </div>
          ) : (
            <>
              <div className="filter_button_container">
                <a data-toggle="modal" data-target="#sort-filter">
                  <div className="icon_bg">
                    <img
                      src={require("../assets/images/list.png")}
                      className="icon_img"
                    />
                  </div>
                </a>
                <a data-toggle="modal" data-target="#filter">
                  <div className="icon_bg">
                    <img
                      src={require("../assets/images/sort.png")}
                      className="icon_img"
                    />
                  </div>
                </a>
                <a data-toggle="modal" data-target="#search">
                  <div className="icon_bg">
                    <img
                      src={require("../assets/images/search.png")}
                      className="icon_img"
                    />
                  </div>
                </a>
                <a onClick={this.handleCallSort}>
                  <div
                    className={
                      this.state.callsort == 0
                        ? "icon_bg relative"
                        : "icon_bg_call relative"
                    }
                  >
                    <span
                      className="icon_notification"
                      hidden={this.state.notCalledCount == 0}
                    >
                      {this.state.notCalledCount}
                    </span>
                    <img
                      src={require("../assets/images/telephone.png")}
                      className="icon_img"
                    />
                  </div>
                </a>
              </div>
              {this.state.maintaenanceBanner ? (
                <>
                  <marquee class="maintaenance-text marquee_data">
                    {this.state.maintaenanceBannerText}
                  </marquee>
                  <div class="maintaenance-text text-center timer_data">
                    {this.state.banner_timer}
                  </div>
                </>
              ) : (
                ""
              )}

              <div>
                <List
                  bordered
                  dataSource={paginatedItems}
                  renderItem={(item, key) => {
                    let callclass = "bg-success";
                    let calldetailclass = "bg-success";
                    let ncd = new Date(item.Next_call_dt);
                    let calltime = item.call_time;

                    if (item.status === "" || item.status === null) {
                      callclass = "bg-danger ring animated";
                      calldetailclass = "bg-danger ring animated";
                    } else if (item.status === 0) {
                      callclass = "bg-success";
                      calldetailclass = "bg-danger ring animated";
                      if (
                        item.Preferred_date === "" ||
                        item.Preferred_date === null
                      ) {
                        if (
                          new Date().getTime() >
                          new Date(ncd.setDate(ncd.getDate() + 5)).getTime()
                        ) {
                          callclass = "bg-danger ring animated";
                        } else {
                          callclass = "bg-success";
                        }
                      }
                    } else if (item.state === 1) {
                      callclass = "bg-success";
                      calldetailclass = "bg-success";
                      if (
                        new Date(ncd).getTime() <
                          new Date(calltime).getTime() &&
                        new Date(calltime).getTime() <
                          new Date(item.Preferred_date).getTime()
                      ) {
                        callclass = "bg-success";
                        calldetailclass = "bg-success";
                        return;
                      }
                      if (
                        new Date(calltime).getTime() > new Date(ncd).getTime()
                      ) {
                        callclass = "bg-danger ring animated";
                        calldetailclass = "bg-danger ring animated";
                      }
                      if (
                        new Date(calltime).getTime() >
                        new Date(item.Preferred_date).getTime()
                      ) {
                        callclass = "bg-success";
                        calldetailclass = "bg-success";
                      }
                    }

                    return (
                      <div className="hh_white_block" key={key}>
                        <div className="name_hh_block">
                          <div className="d-flex flex-column">
                            <div className="name">
                              {item.Nach_flag === "1" ? (
                                <img
                                  src={require("../assets/images/nach.png")}
                                  alt=""
                                  className="nach-img"
                                />
                              ) : (
                                ""
                              )}
                              {item.Lead_Name}
                            </div>
                            <b>
                              <span className="justify-content-left">
                                EMI: Rs.{" "}
                                {item.emi &&
                                  parseFloat(item.emi).toLocaleString("en-IN")}
                              </span>
                            </b>

                            <span className="branch_bluetext">
                              {item.Location_Name}
                            </span>
                          </div>
                          <div className="d-flex flex-column">
                            <span className="name">{item.HH_ID}</span>
                          </div>
                          <div className="d-flex justify-content-around">
                            {process.env.REACT_APP_CSO_QRSMS &&
                            process.env.REACT_APP_CSO_QRSMS !== null ? (
                              process.env.REACT_APP_CSO_QRSMS.toLowerCase().includes(
                                localStorage
                                  .getItem("in_username")
                                  .toLowerCase()
                              ) ? (
                                <button
                                  className="msg_icon_bg mx-1"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.sendqrsms(
                                      item.household_id,
                                      item.Household_mobile_no,
                                      item.Balance,
                                      item.Charges_OS,
                                      item.emi,
                                      item.Loan_os,
                                      item.Lead_Name,
                                      item.HH_ID
                                    );
                                  }}
                                >
                                  <img
                                    src={require("../assets/images/salary.png")}
                                    className="msg_icon_img"
                                  />
                                </button>
                              ) : (
                                ""
                              )
                            ) : (
                              <button
                                className="msg_icon_bg mx-1"
                                onClick={() => {
                                  this.setState({
                                    fliped: false,
                                    isOpenCollect: true,
                                    payment_method: "",
                                    total_amt: "",
                                    smsmobile: item.Household_mobile_no,
                                    alternate_mobile_number:
                                      item.alternate_mobile_number,
                                    smsread: true,
                                    altmobread: true,
                                    Lead_Name: item.Lead_Name,
                                    HH_ID: item.HH_ID,
                                    household_id: item.household_id,
                                    Charges_OS: item.Charges_OS,
                                    previous_transactions:
                                      item.previous_transactions,
                                    Balance: item.Balance,
                                    partner_flag: item.partner_flag,
                                    product_id: item.product_id,
                                    Branch_ID: item.Branch_ID,
                                  });
                                }}
                              >
                                <img
                                  src={require("../assets/images/salary.png")}
                                  className="msg_icon_img"
                                />
                              </button>
                            )}
                            <a
                              href={"tel:+91" + item.Household_mobile_no}
                              className={`call_icon_bg mx-1 ${callclass}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                // this.handleCall(item.household_id);
                              }}
                            >
                              <img
                                src={require("../assets/images/telephone (2).png")}
                                className="call_icon_img"
                              />
                            </a>
                          </div>
                        </div>
                        <br />
                        <div className="amt_details_block">
                          <div>
                            <span className="bluetext">Demand</span>
                            <div className="dem_block">
                              Rs.{" "}
                              {(
                                parseFloat(item.Demand) +
                                (item.other_charges_due
                                  ? parseFloat(item.other_charges_due)
                                  : 0) +
                                (item.interest_od
                                  ? parseFloat(item.interest_od)
                                  : 0)
                              ).toLocaleString("en-IN")}
                            </div>
                            <div>
                              <span className="w-100">
                                <h6>
                                  <small>
                                    Amount:{" "}
                                    {(
                                      item.Demand &&
                                      parseFloat(item.Demand) +
                                        (item.interest_od
                                          ? parseFloat(item.interest_od)
                                          : 0)
                                    ).toLocaleString("en-IN")}
                                  </small>
                                </h6>

                                <h6>
                                  <small>
                                    Charges:
                                    {" " + item.other_charges_due &&
                                      item.other_charges_due != null &&
                                      parseFloat(
                                        item.other_charges_due
                                      ).toLocaleString("en-IN")}
                                  </small>
                                </h6>
                              </span>
                            </div>
                          </div>
                          <div>
                            <span className="greentext_sh">Collected</span>

                            <div className="col_block">
                              Rs.{" "}
                              {(
                                parseFloat(item.Collected) +
                                (item.Other_charges_rcvd
                                  ? parseFloat(item.Other_charges_rcvd)
                                  : 0)
                              ).toLocaleString("en-IN")}
                            </div>
                            <div>
                              <span className="w-100">
                                <h6>
                                  <small>
                                    Amount:{" "}
                                    {item.Collected &&
                                      parseFloat(item.Collected).toLocaleString(
                                        "en-IN"
                                      )}
                                  </small>
                                </h6>
                                <h6>
                                  <small>
                                    Charges:
                                    {" " + item.Other_charges_rcvd &&
                                      item.Other_charges_rcvd != null &&
                                      parseFloat(
                                        item.Other_charges_rcvd
                                      ).toLocaleString("en-IN")}
                                  </small>
                                </h6>
                              </span>
                            </div>
                          </div>
                          <div>
                            <span className="redtext_sh">Balance</span>
                            <div className="bal_block">
                              Rs.{" "}
                              {(
                                parseFloat(item.Balance) +
                                (item.Charges_OS
                                  ? parseFloat(item.Charges_OS)
                                  : 0)
                              ).toLocaleString("en-IN")}
                            </div>
                            <div>
                              <span className="w-100">
                                <h6>
                                  <small>
                                    Amount:{" "}
                                    {" " + item.Balance &&
                                      parseFloat(item.Balance).toLocaleString(
                                        "en-IN"
                                      )}
                                  </small>
                                </h6>
                                <h6>
                                  <small>
                                    Charges:
                                    {" " + item.Charges_OS &&
                                      item.Charges_OS != null &&
                                      parseFloat(
                                        item.Charges_OS
                                      ).toLocaleString("en-IN")}
                                  </small>
                                </h6>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }}
                />
                <div className="mt-2 text-center">
                  {paginatedItems.length > 0 && (
                    <Pagination
                      current={currentPage}
                      pageSize={pageSize}
                      total={cnames.length}
                      onChange={this.handlePageChange}
                      showSizeChanger
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        {/* <PreviousTransactions
          isModalOpen={this.state.isModalOpen}
          handleCancel={this.handleCancelModal}
          handleOk={this.handleOkModal}
          previousTransactions={this.state.previous_transactions}
        /> */}
        <ChatSupportBtn history={this.props.history} />
      </>
    );
  }
}

export default withRouter(Other_collection);
